// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const CHART_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY = {
  CATEGORY_LABELS_ON: 'chart.categoryLabels.enabled',
  VALUE_LABELS_ON: 'chart.valueLabels.enabled',
  VALUE_PERCENT_LABELS_ON: 'chart.valuePercentLabels.enabled',
  VALUE_LABELS_FONT_SIZE: 'chart.valueLabels.fontSize',
  CATEGORY_AXIS_LABELS_ON: 'chart.categoryAxisLabels.enabled',
  VALUE_AXIS_LABELS_ON: 'chart.valueAxisLabels.enabled',
  CATEGORY_AXIS_LOCATION: 'chart.categoryAxisLocation',
  VALUE_AXIS_LOCATION: 'chart.valueAxisLocation',
  LEGEND_ON: 'chart.legend.enabled',
  CATEGORY_AXIS_SCROLLBAR_ON: 'chart.scrollbar.enabled',
  VALUE_AXIS_SCROLLBAR_ON: 'chart.valueAxisScrollbar.enabled',
  VALUE_AXIS_MERGE_ON: 'chart.valueAxisMerge.enabled',
  MAX_DATA_RECORDS_STRATEGY: 'chart.maxDataRecordsStrategy',
  CATEGORY_AXIS_TITLE_ON: 'chart.categoryAxisTitle.enabled',
  CATEGORY_AXIS_TITLE_TEXT: 'chart.categoryAxisTitle.text',
  VALUE_AXIS_TITLE_ON: 'chart.valueAxisTitle.enabled',
  VALUE_AXIS_TITLE_TEXT: 'chart.valueAxisTitle.text',
  REALTIME: 'chart.realtime',
  REALTIME_PERIOD: 'chart.realtime.update.period',
  LINE_CHART_MAX_MEASURES: 'chart.lineChart.maxMeasures',
  MULTI_LINE_CHART_MAX_MEASURES: 'chart.multiLineChart.maxMeasures',
  PIE_CHART_MAX_MEASURES: 'chart.pieChart.maxMeasures',
  BAR_CHART_MAX_MEASURES: 'chart.barChart.maxMeasures',
  HUNDRED_PERCENT_BAR_CHART_MAX_MEASURES: 'chart.hundredPercentBarChart.maxMeasures',
  STACKED_BAR_CHART_MAX_MEASURES: 'chart.stackedBarChart.maxMeasures',
  GROUPED_BAR_CHART_MAX_MEASURES: 'chart.groupedBarChart.maxMeasures',
  COLUMN_CHART_MAX_MEASURES: 'chart.columnChart.maxMeasures',
  HUNDRED_PERCENT_COLUMN_CHART_MAX_MEASURES: 'chart.hundredPercentColumnChart.maxMeasures',
  STACKED_COLUMN_CHART_MAX_MEASURES: 'chart.stackedColumnChart.maxMeasures',
  STACKED_AREA_CHART_MAX_MEASURES: 'chart.stackedAreaChart.maxMeasures',
  GROUPED_COLUMN_CHART_MAX_MEASURES: 'chart.groupedColumnChart.maxMeasures',
  VALUE_AXIS_MIN_DISPLAYED_VALUE: 'chart.dataMinDisplayedValue',
  CATEGORY_AXIS_MIN_DISPLAYED_VALUE: 'chart.categoryAxisDataMinDisplayedValue',
  VALUE_AXIS_MAX_DISPLAYED_VALUE: 'chart.dataMaxDisplayedValue',
  CATEGORY_AXIS_MAX_DISPLAYED_VALUE: 'chart.categoryAxisDataMaxDisplayedValue',
  VALUE_AXIS_USE_LOGARITHMIC_SCALE: 'chart.logarithmicScale.enabled',
  CATEGORY_AXIS_USE_LOGARITHMIC_SCALE: 'chart.categoryAxisLogarithmicScale.enabled',
  PIE_CHART_LABEL_ALIGNMENT: 'chart.labelAlignment',
  DISPLAY_LINE_CHART_BULLETS: 'chart.displayLineChartBullets',
  PIE_CHART_LEGEND_ON: 'chart.pieChart.legend.enabled',
  LINE_CHART_PATTERN: 'chart.lineChart.pattern',
  SCATTER_PLOT_POINT_SIZE: 'chart.scatterPlot.pointSize',
  SCATTER_PLOT_CATEGORY_AXIS_SCROLLBAR_ON: 'chart.scatterPlot.categoryAxisLabels.enabled',
  SCATTER_PLOT_VALUE_AXIS_SCROLLBAR_ON: 'chart.scatterPlot.valueAxisScrollbar.enabled',
  LINE_WIDTH: 'chart.line.width',
  ANALYTIC_LINE_RENDER_ORDER: 'chart.analyticLine.renderOrder',
  REFERENCE_LINE_STATIC_VALUE: 'chart.referenceLine.staticValue'
} as const;

/** @see net/disy/cadenza/workbook/model/ChartDataViewSettingsKey.java */
export type ChartDataViewSettingsKey = keyof typeof CHART_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY;

export const ChartDataViewSettingsKey = {
  values: Object.keys(CHART_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY) as readonly ChartDataViewSettingsKey[],
  toPersistenceKey: (value: ChartDataViewSettingsKey) => CHART_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = ChartDataViewSettingsKey.values.find(key => CHART_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No ChartDataViewSettingsKey for key: ${persistenceKey}`); }
    return value;
  },
} as const;

// </GENERATED-CODE>
